import { SelectionModel } from "@angular/cdk/collections";
import { Component, inject, input, OnInit, output } from "@angular/core";
import { MatSortModule, Sort } from "@angular/material/sort";
import { QuoteStatus } from "../../../modals/quote-create-modal/types/Quote";
import { QuoteSearchRow } from "../types/QuoteSearchRow";
import { QuoteEditModalService } from "../../../modals/quote-edit-modal/quote-edit-modal.service";
import { QuoteStatusDropdowns } from "../../../modals/quote-edit-modal/types/QuoteStatusDescriptionDto";
import { MatTableModule } from "@angular/material/table";
import { CommonModule } from "@angular/common";

@Component({
  selector: 'quote-search-results',
  templateUrl: 'quote-search-results-grid.component.html',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatSortModule],
  providers: [QuoteEditModalService]
})
export class QuoteSearchResultsGridComponent implements OnInit {
  private quoteEditModalService = inject(QuoteEditModalService);

  public selection = new SelectionModel<QuoteSearchRow>(false);

  public quotes = input<QuoteSearchRow[]>([]);
  public onEdit = output<QuoteSearchRow>();
  public sortChanged = output<Sort>();

  public quoteStatusDropdowns: QuoteStatusDropdowns[] = [];

  ngOnInit() {
    this.quoteEditModalService.GetQuoteStatusDropdownList().subscribe((dropdowns) => {
      this.quoteStatusDropdowns = dropdowns;
    });
  };

  public readonly COLUMNS = [
    "number",
    "year",
    "person",
    "budgetYear",
    "counts",
    "committed",
    "currency",
    "status",
    "pr",
    "purchaseOrder",
    "docs",
    "name",
    "code",
    "country",
    "contact",
    "paidByCommercial"
  ] as const;

  protected doubleClick(row: QuoteSearchRow) {
    if (!this.selection.isSelected(row))
      this.selection.toggle(row);

    this.onEdit.emit(row);
  }

  protected onSortChange(evt: Sort) {
    this.sortChanged.emit(evt);
  }

  protected QuoteStatusDescription = (status: QuoteStatus) => this.quoteStatusDropdowns.filter((x) => x.Status == status)[0].Description;
}
